/****************************************
	/js/v2/paging.js
*****************************************/
;(function ($) {
	'use strict';
	var shared = {
			'addCommas': function (val) {
				/* Internation periods and commas are switched */
				var separator = ',';
				if (this.lang.toLowerCase().substr(0, 2) !== 'en') {
					separator = '.';
				}
				while (/(\d+)(\d{3})/.test(val.toString())) {
					val = val.toString().replace(/(\d+)(\d{3})/, '$1' + separator + '$2');
				}
				return val;
			},
			'isNumber': function (n) {
				return !isNaN(parseFloat(n)) && isFinite(n);
			},
			'lang': (function () {
				var langAttr = $('html').attr('lang') || $('[lang]').first().attr('lang');
				return langAttr ? langAttr.toLowerCase() : 'en';
			}()),
			'localize': function (langSet, key) {
				if (langSet[this.lang] && langSet[this.lang][key]) {
					return langSet[this.lang][key];
				}
				if (langSet[this.lang.substring(0, 2)] && langSet[this.lang.substring(0, 2)][key]) {
					return langSet[this.lang.substring(0, 2)][key];
				}
				return langSet.en[key] || '';
			},
			'warn': function (msg, useAlert) {
				if (window.console) {
					console.warn(msg);
					if (useAlert && /ancestry(?:stage|dev)/.test(window.location.hostname)) {
						alert(msg);
					}
				}
			}
		},
		paging = {
			'create': function ($element, options) {
				var instance = $element.data('paging'),
					dataOptions = {
						'total': $element.filter('[data-paging-total]').data('paging-total'),
						'current': $element.data('paging-current'),
						'url': $element.data('paging-url'),
						'nextUrl': $element.data('paging-next-url'),
						'previousUrl': $element.data('paging-previous-url')
					};
				if (instance) {
					instance.destroy();
				}
				instance = Object.create(this.proto);
				instance.config = $.extend({}, this.staticProperties.defaults, dataOptions, options);
				instance.$element = $element;
				if (!instance.config.total) {
					shared.warn('total must be passed in');
					instance.destroy();
					return false;
				}
				instance.config.current = Math.min(instance.config.total, instance.config.current);
				instance.$element
					.addClass('paging')
					.data('paging', instance)
					.html(instance._createHtml());
				instance.$input = instance.$element.find('input, select');
				instance.$next = instance.$element.find('.pagingNext');
				instance.$prev = instance.$element.find('.pagingPrevious');
				instance.$dropdown = instance.$element.find('.pagingSelect');
				instance._addEvents();
				return instance;
			},
			'proto': {
				'_addEvents': function () {
					var self = this,
						allowPageChange = true;
					this.$element
						.on('click.paging', '.pagingNext, .pagingPrevious', function () {
							var $this = $(this);
							if ($this.hasClass('disabled')) {
								return false;
							}
							if (self.config.previousUrl || self.config.nextUrl) {
								return;
							}
							if ($this.hasClass('pagingNext')) {
								self.goToPage(self.config.current + 1);
							} else {
								self.goToPage(self.config.current - 1);
							}
							return false;
						})
						.on('focusin.paging', 'input', function () {
							var input = this;
							setTimeout(function () {
								input.select();
							}, 1);
						})
						.on('focusout.paging', 'input', function () {
							if (allowPageChange) {
								self.goToPage($(this).val());
							}
							allowPageChange = true;
						})
						.on('keydown.paging', 'input', function (e) {
							/* ESC reverts to original value */
							if (e.keyCode === 27) {
								allowPageChange = false;
								$(this).val(self.config.current).blur();
							/* ENTER triggers a blurs event */
							} else if (e.keyCode === 13) {
								$(this).blur();
								return false; /* Do not submit form */
							}
						})
						.on('change.paging', 'select', function () {
							self.goToPage($(this).val());
						});
				},
				'_checkPageRange': function (page) {
					if (page < 1) {
						return 1;
					} else if (page > this.config.total) {
						return this.config.total;
					} else {
						return page;
					}
				},
				'_createDropdownOptions': function () {
					var config = this.config,
						current,
						html = '',
						key;
					for (key in config.allowedPages) {
						if (config.allowedPages.hasOwnProperty(key)) {
							current = key === config.current.toString() ? ' selected' : '';
							html += this
								._getTemplate('option')
								.replace('{option}', key)
								.replace('{isSelected}', current);
						}
					}
					return html;
				},
				'_createHtml': function () {
					var config = this.config,
						current,
						html,
						input,
						nextUrl,
						pages,
						previousUrl;
					/* Page Selector Template */
					if (config.allowSkipping) {
						input = this._getTemplate('input');
						current = config.current;
					} else if (config.display === 'select' && config.allowedPages) {
						input = this._getTemplate('select');
						current = config.current;
						pages = this._createDropdownOptions();
					} else {
						input = this._getTemplate('numText');
						current = shared.addCommas(config.current);
					}
					/* PreviousURL Template */
					if (config.previousUrl) {
						previousUrl = config.previousUrl;
					} else if (config.allowedPages) {
						previousUrl = this._getPreviousAllowedUrl();
					} else {
						previousUrl = config.url + this._checkPageRange(config.current - 1);
					}
					/* NextUrl Template */
					if (config.nextUrl) {
						nextUrl = config.nextUrl;
					} else if (config.allowedPages) {
						nextUrl = this._getNextAllowedUrl();
					} else {
						nextUrl = config.url + this._checkPageRange(config.current + 1);
					}
					html = this
						._getTemplate('html')
						.replace('{input}', input)
						.replace('{current}', current)
						.replace('{pages}', pages)
						.replace('{enablePrevious}', config.current === 1 ? ' disabled" aria-disabled="true' : '')
						.replace('{min}', config.current)
						.replace('{max}', config.total)
						.replace('{total}', shared.addCommas(config.total))
						.replace('{enableNext}', config.current === config.total ? ' disabled" aria-disabled="true' : '')
						.replace('{previousUrl}', previousUrl)
						.replace('{nextUrl}', nextUrl);
					return html;
				},
				'destroy': function () {
					this.$element
						.html('')
						.off('.paging')
						.removeData('paging-current paging-next-url paging-previous-url paging-total paging-url paging')
						.removeClass('paging');
				},
				'_disabledAttributes': function ($element, removeAttributes) {
					if (removeAttributes) {
						$element
							.removeClass('disabled')
							.removeAttr('aria-disabled');
					} else {
						$element
							.addClass('disabled')
							.attr('aria-disabled', true);
					}
				},
				'_getNextAllowedUrl': function () {
					return this.config.allowedPages[this.config.current + 1] || '#';
				},
				'_getPreviousAllowedUrl': function () {
					return this.config.allowedPages[this.config.current - 1] || '#';
				},
				'_getTemplate': function (template) {
					var langSets = paging.staticProperties.langSets,
						html = {
							'html': '<a href="{previousUrl}" class="pagingPrevious button button-4 button-square{enablePrevious}" rel="prev"><span class="show-mobile-portrait">' + shared.localize(langSets, 'prevPageShort') + '</span><span class="hide-mobile-portrait">' + shared.localize(langSets, 'prevPage') + '</span></a>{input}<a class="pagingNext button button-4 button-square{enableNext}" href="{nextUrl}" rel="next"><span class="show-mobile-portrait">' + shared.localize(langSets, 'nextPageShort') + '</span><span class="hide-mobile-portrait">' + shared.localize(langSets, 'nextPage') + '</span></a>',
							'input': '<input class="field" aria-label="' + shared.localize(langSets, 'newPageNumber') + '" type="number" value="{current}" min="{min}" max="{max}" />',
							'numText': '<span class="pagingMeta"><span class="pagingNum">{current}</span> ',
							'select': '<span class="form"><select aria-label="' + shared.localize(langSets, 'selectPage') + '" class="pagingSelect" id="selectSomething">{pages}</select></span><span class="pagingMeta">',
							'option': '<option {isSelected}>{option}</option>'
						};
					return html[template];
				},
				'goToPage': function (page) {
					var config = this.config;
					page = parseInt((page.toString()).replace(/[,.]/g, ''), 10);
					this.$input.removeClass('error');
					if (!shared.isNumber(page)) {
						this.$input.addClass('error');
						return false;
					}
					if (config.current === page) {
						return false;
					}
					page = this._checkPageRange(page);
					this._disabledAttributes(this.$next.add(this.$prev), true);
					if (page === 1) {
						this._disabledAttributes(this.$prev);
					} else if (page === config.total) {
						this._disabledAttributes(this.$next);
					}
					this.$input.val(page);
					config.current = page;
					this.$element.find('.pagingNum').html(page);
					this.$prev.attr('href', config.allowedPages ? this._getPreviousAllowedUrl() : config.url + this._checkPageRange(config.current - 1));
					this.$next.attr('href', config.allowedPages ? this._getNextAllowedUrl() : config.url + this._checkPageRange(config.current + 1));
					if (config.onChange && config.onChange.apply(this.$element, [page]) !== true) {
						return false;
					}
					if (config.allowedPages && config.allowedPages[page] !== '') {
						window.location = config.allowedPages[page];
					} else {
						window.location = config.url + page;
					}
				},
				'replaceDropdown': function (newAllowedPages) {
					this.config.allowedPages = newAllowedPages;
					this.$dropdown.html(this._createDropdownOptions());
					this.$prev.attr('href', this._getPreviousAllowedUrl());
					this.$next.attr('href', this._getNextAllowedUrl());
				}
			},
			'staticProperties': {
				'defaults': {
					'current': 1,
					'url': '#page=',
					'onChange': false,
					'allowSkipping': true,
					'display': 'input',
					'allowedPages': false
				},
				'langSets': {
					'en': {
						'newPageNumber': 'Enter new page number',
						'nextPage': 'Next Page >',
						'nextPageShort': 'Next >',
						'of': 'of',
						'prevPage': '< Previous Page',
						'prevPageShort': '< Previous',
						'selectPage': 'Select new page number'
					}
				}
			}
		},
		version = 2,
		doubleIncluded = !!$.paging;
	if (doubleIncluded) {
		if ($.paging.version === version) {
			shared.warn('ERROR: You are including paging.js multiple times');
			return;
		} else {
			shared.warn('ERROR: You are including multiple versions of paging.js');
			if ($.paging.version > version) {
				return;
			}
		}
	}
	/* Plugin definition */
	$.fn.paging = function (options) {
		/* We cannot use .each because that will break binding 2 sets together */
		var args = arguments,
			instance = this.data('paging'),
			isMethodCall = typeof options === 'string', /* If options is a string, we assume it refers to a method. */
			methodValue,
			returnValue = this;
		if (instance && shared.isNumber(options)) {
			shared.warn('You should be using $(selector).paging(\'goToPage\', 2)');
			instance.goToPage(options);
		} else if (isMethodCall) {
			if (!instance) {
				shared.warn('Cannot call methods on paging prior to initialization; attempted to call method "' + options + '".');
				return false;
			}
			if (!$.isFunction(instance[options]) || options.indexOf('_') === 0) {
				shared.warn('No such method "' + options + '" for paging.');
				return false;
			}
			methodValue = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
			if (methodValue !== instance && methodValue !== undefined) {
				returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
				return false;
			}
		} else {
			paging.create($(this), options);
		}
		return returnValue;
	};
	/* Expose testable methods */
	$.paging = {
		'getTest': function () {
			return $.extend({}, paging);
		},
		'version': version
	};
	if (!doubleIncluded) {
		/* Auto-instantiate where needed */
		$(function () {
			$('[data-paging-total]:not([data-auto-instantiate="off"])').each(function () {
				$(this).paging();
			});
		});
	}
}(jQuery));
